import React from 'react'

import { ThemeStore } from '../stores/ThemeStore'
import { CoinStore } from '../stores/CoinStore'
import { AlertStore } from '../stores/AlertStore'

function ThemeSelect(defaultValue, onChange) {
	return (
		<select defaultValue={defaultValue} onChange={onChange}>
			{
				ThemeStore.getAllNames().map(val => {
					var name = val.charAt(0).toUpperCase() + val.slice(1)
					return <option key={val} value={val}>{name}</option>
				})
			}
  	</select>
	)
}

function ChartTypeSelect(defaultValue, onChange) {
	return (
		<select defaultValue={defaultValue} onChange={onChange}>
			{
				ThemeStore.getAllChartTypes().map(arr => {
					let [val, name] = arr
					return <option key={val} value={val}>{name}</option>
				})
			}
  	</select>
	)
}

export default class Settings extends React.Component {
	changeTheme = (e) => {
		var name = e.target.value
		ThemeStore.set(name)
		// location.reload()
		document.body.className = 'theme-' + name
	}

	setUpdateInterval = (e) => {
		CoinStore.setUpdateInterval(e.target.value)
	}

	setRearmInterval = (e) => {
		AlertStore.setRearmInterval(e.target.value)
	}

	changeChartType = (e) => {
		ThemeStore.setChartType(e.target.value)
	}

	render() {
		return (
			<div className='absolute settings z-index-100 shadow-2'>
				<div className='w-100'>
          <button className='bg-animate' onClick={this.props.onCancel}>Close</button>
        </div>
        <div className='w-100 pa2 mt2'>
        	<span className='di pr1'>Theme:</span>
					{ ThemeSelect(ThemeStore.name(), this.changeTheme) }
				</div>
				<div className='w-100 pa2 mt2'>
        	<span className='di pr1'>Chart:</span>
					{ ChartTypeSelect(ThemeStore.getChartType(), this.changeChartType) }
				</div>
				<div className='w-100 pa2'>
        	<span className='di pr1'>Price Update Interval:</span>
					<input defaultValue={CoinStore.getUpdateInterval()} onChange={this.setUpdateInterval}
						type="text" className="input-reset ba b--black-20 pa2 mb2 di w-20" />
					&nbsp;seconds
				</div>
				<div className='w-100 pa2'>
        	<span className='di pr1'>Alert Rearm Interval:</span>
					<input defaultValue={AlertStore.getRearmInterval()} onChange={this.setRearmInterval}
						type="text" className="input-reset ba b--black-20 pa2 mb2 di w-20" />
					&nbsp;minutes
					<br/>
					<small>Turn off Do Not Disturb for notification to work!</small>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Settings.js